<template>
    <footer class="footer">
        <div class="container">
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright text-center text-sm-left">
                        &copy; {{year}}
                        <a href="https://advancedcloudservices.ie" target="_blank" rel="noopener">Advanced Cloud Services</a>
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-center justify-content-sm-end pt-0">
                        <li class="nav-item">
                            <router-link
                              tag="a"
                              to="/privacy-policy"
                              class="nav-link">
                            Privacy Policy
                          </router-link>
                        </li>
                        <li class="nav-item">
                          <router-link
                            tag="a"
                            to="/about-us"
                            class="nav-link">
                            About Us
                          </router-link>
                        </li>
                        <li class="nav-item">
                          <router-link
                            tag="a"
                            to="/contact-us"
                            class="nav-link">
                            Contact Us
                          </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
